import { render } from "./EdoDocumentTitleDetailsPanel.vue?vue&type=template&id=b0e9eb78&scoped=true"
import script from "./EdoDocumentTitleDetailsPanel.vue?vue&type=script&lang=js"
export * from "./EdoDocumentTitleDetailsPanel.vue?vue&type=script&lang=js"

import "./EdoDocumentTitleDetailsPanel.vue?vue&type=style&index=0&id=b0e9eb78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0e9eb78"]])

export default __exports__